import { FormControlLabel, RadioGroup } from '@mui/material';
import Box from '@mui/material/Box';
import Radio from '@mui/material/Radio';
import Typography from '@mui/material/Typography';
import { SystemStyleObject } from '@mui/system/styleFunctionSx/styleFunctionSx';
import React from 'react';

import { useTranslator } from '@/hooks/useTranslator';
import { FiatAccountType } from '@/types/fiatAccountType';

interface Props {
  readonly defaultValue: FiatAccountType.ach | FiatAccountType.swift | FiatAccountType.wire;
  onChange(value: FiatAccountType.ach | FiatAccountType.swift | FiatAccountType.wire): void;
}

export const USPaymentMethodSelector: React.FC<Props> = (props: Props): React.ReactElement => {
  const { defaultValue, onChange } = props;
  const tr = useTranslator();

  const handlePaymentMethodChange = React.useCallback(
    (event: React.ChangeEvent<HTMLInputElement>): void => {
      const { value } = event.target;
      switch (value) {
        case FiatAccountType.ach:
        case FiatAccountType.wire:
          onChange(value);
          break;
        default:
          console.debug('invalid fiat account type: ', value);
      }
    },
    [onChange],
  );

  return (
    <Box display="flex" flexDirection="column" gap={3}>
      <Typography fontSize={16} fontWeight={400} lineHeight="24px">
        {tr('PAYMENT_METHOD')}
      </Typography>
      <RadioGroup defaultValue={defaultValue} onChange={handlePaymentMethodChange}>
        <Box display="flex" alignItems="center" justifyContent="space-between">
          <FormControlLabel
            sx={styles.control}
            control={
              <Box ml={-1}>
                <Radio value={FiatAccountType.ach} />
              </Box>
            }
            label={
              <Typography fontSize={16} whiteSpace="nowrap" color="text.primary">
                {tr('ACH')}
              </Typography>
            }
          />
          <FormControlLabel
            sx={styles.control}
            control={
              <Box ml={-1}>
                <Radio value={FiatAccountType.wire} />
              </Box>
            }
            label={
              <Typography fontSize={16} whiteSpace="nowrap" color="text.primary">
                {tr('WIRE')}
              </Typography>
            }
          />
        </Box>
      </RadioGroup>
    </Box>
  );
};

const styles: Record<string, SystemStyleObject> = {
  control: {
    display: 'flex',
    flexGrow: 1,
    alignItems: 'center',
    margin: 0,
    height: 24,
  },
};
